import { Avatar, Col, Row, Text } from 'components';
import { capitalize, formatLocale, theme } from 'lib';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { TableComponents } from 'screens/Admin/components';

const ENTITY_LABELS = {
  post: 'Post',
  story: 'Story',
  shoutout: 'Shoutout',
  fancam: 'FanCam',
  comment: 'Comment',
  user: 'User',
  fanchat: 'FanChat'
};

const ENTITY_LABEL_KEYS = {
  fanchatTopic: 'admin.reports.entityTypes.fanchatTopic',
  fanchatMessage: 'admin.reports.entityTypes.fanchatMessage'
};

const ListItem = memo(({ item, onClick = null, dataId }) => {
  const { t } = useTranslation();
  const isSelected = dataId === item._id,
    { createdAt, entityType, reported, description, status = 'pending' } = item;

  return (
    <TableComponents.Tr onClick={() => onClick(item._id)} isSelected={isSelected}>
      <TableComponents.Td isSelected={isSelected} first>
        <Row>
          <Avatar user={reported} small />

          <Col center marg="0 0 0 12px">
            <Text>{reported?.name}</Text>
            <Text c1 col={theme.GREY_60}>
              @{reported?.username}
            </Text>
          </Col>
        </Row>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text>{capitalize(description)}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text>
            {ENTITY_LABEL_KEYS[entityType]
              ? t(ENTITY_LABEL_KEYS[entityType])
              : ENTITY_LABELS[entityType] || capitalize(entityType)}
          </Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text>
            {status === 'contentRemoved' ? 'Content removed' :
             status === 'blocked' ? 'Blocked' :
             status === 'unblocked' ? 'Unblocked' :
             capitalize(status)}
          </Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected} last>
        <Col noFlex>
          <Text>
            {item.createdAt ? formatLocale(new Date(createdAt), 'LLL do yyy, hh:mm a') : ''}
          </Text>
        </Col>
      </TableComponents.Td>
    </TableComponents.Tr>
  );
});

export default ListItem;
